<template>
    <div class="px-2 w-full md:w-9/12 lg:w-7/12 m-auto mt-12 flex">
        <div class="px-4">
            <h1 class="text-xl py-2"> Dash </h1>
            <div class="bg-white w-60 border rounded flex flex-col">
                <router-link :to="{path:'/admin/users'}" class="p-2 text-gray-500 w-full border-b">
                    Users
                </router-link>
                <router-link :to="{path:'/admin/feedProcessors'}" class="p-2 text-gray-500 w-full border-b">
                    Feed Sources
                </router-link>
                <router-link :to="{path:'/admin/Scenarios'}" class="p-2 text-gray-500 w-full border-b">
                    Scenarios
                </router-link>
                <router-link :to="{path:'/admin/Crawlers'}" class="p-2 text-gray-500 w-full border-b">
                    Crawlers
                </router-link>

            </div>
       
        </div>
        
        <router-view/>
    </div>
  </template>

<script>
   
  export default {
    name: 'adminLayout',
    components: {

    },
    async mounted(){

    },
    data () {
      return {
        
      }
    },
    methods: {
      
    }
  }
  </script>
  
  <style >
  
  </style>


// WEBPACK FOOTER //
// src/pages/Admin/index.vue